import UIFlex from 'UIComponents/layout/UIFlex';
import TX120BaseSurveyModal from './Tx120BaseSurveyModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect, useState } from 'react';
import { upgradeProductSurveyResponseMap } from '../../SurveyResponses';
import { handleSubmitSurveyResponses } from '../../../utils/tx120SurveySubmit';
import TrialRedirectButton from '../../../common/components/activation/tx-120/TrialRedirectButton';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
const Tx120LockedFeatureSurveyModal = ({
  apiName,
  onSuccess,
  upgradeData
}) => {
  const [allFeatures, setSelectedFeatures] = useState(upgradeProductSurveyResponseMap[apiName]);
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  useEffect(() => {
    tracker.track('trialActivationInteraction', Object.assign({
      action: 'viewed locked feature survey modal'
    }, upgradeData));
  }, [upgradeData]);
  const handleCreateTrialGuide = async () => {
    if (isOtherSelected) {
      tracker.track('trialActivationInteraction', Object.assign({
        action: 'selected other'
      }, upgradeData));
    }
    await handleSubmitSurveyResponses(apiName, allFeatures, upgradeData);
    if (onSuccess) {
      onSuccess();
    }
  };
  const renderModalFooter = className => {
    return /*#__PURE__*/_jsx(UIFlex, {
      align: "center",
      direction: "column",
      className: className,
      children: /*#__PURE__*/_jsx(TrialRedirectButton, {
        use: "primary",
        onClick: handleCreateTrialGuide,
        buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.tx0120.lockedFeatureModal.startExploringButton"
        }),
        upgradeData: upgradeData
      })
    });
  };
  return /*#__PURE__*/_jsx(TX120BaseSurveyModal, {
    modalTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.tx0120.lockedFeatureModal.modalTitle"
    }),
    headline: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.tx0120.lockedFeatureModal.headline"
    }),
    apiName: apiName,
    renderModalFooter: renderModalFooter,
    allFeatures: allFeatures,
    isOtherSelected: isOtherSelected,
    setSelectedFeatures: setSelectedFeatures,
    setIsOtherSelected: setIsOtherSelected
  });
};
export default Tx120LockedFeatureSurveyModal;